import * as echarts from "echarts/core";

export const ECHART_COLORS = {
  primary: "#1E40AF",
  primaryLight: "#3B82F6",
  accent: "#D97706",
  accentLight: "#F59E0B",
  success: "#10B981",
  danger: "#EF4444",
  purple: "#8B5CF6",
  slate: "#64748B",
  teal: "#0EA5E9",
  rose: "#F43F5E",
  indigo: "#6366F1",
  emerald: "#059669",
};

export const ECHART_PALETTE = [
  "#1E40AF",
  "#D97706",
  "#10B981",
  "#8B5CF6",
  "#0EA5E9",
  "#F43F5E",
  "#6366F1",
  "#059669",
  "#F59E0B",
  "#64748B",
];

export const ECHART_STATUS_COLORS = {
  Pending: "#F59E0B",
  Confirmed: "#3B82F6",
  "In Progress": "#6366F1",
  Picked: "#0EA5E9",
  Shipped: "#8B5CF6",
  Delivered: "#10B981",
  Completed: "#059669",
  Cancelled: "#EF4444",
  Returned: "#F43F5E",
  "Partially Fulfilled": "#D97706",
};

export function getColorForLabel(label, index) {
  if (ECHART_STATUS_COLORS[label]) return ECHART_STATUS_COLORS[label];
  return ECHART_PALETTE[index % ECHART_PALETTE.length];
}

export const ECHART_GRID = {
  left: "3%",
  right: "4%",
  bottom: "3%",
  top: "10%",
  containLabel: true,
};

export const ECHART_TEXT_STYLE = {
  fontFamily: "inherit",
  color: "#334155",
};

export const ECHART_AXIS_LINE = { lineStyle: { color: "#CBD5E1" } };
export const ECHART_SPLIT_LINE = { lineStyle: { color: "#F1F5F9" } };
export const ECHART_AXIS_LABEL = { color: "#64748B", fontSize: 11 };

export const ECHART_TOOLTIP = {
  backgroundColor: "rgba(255,255,255,0.95)",
  borderColor: "#E2E8F0",
  borderWidth: 1,
  textStyle: { color: "#1E293B", fontSize: 12 },
  extraCssText: "box-shadow: 0 4px 12px rgba(0,0,0,0.08); border-radius: 8px;",
};

export const ECHART_TOOLBOX = {
  right: 10,
  top: 0,
  feature: {
    saveAsImage: {
      title: "Export PNG",
      pixelRatio: 2,
      backgroundColor: "#fff",
    },
  },
  iconStyle: { borderColor: "#64748B" },
};

export function registerEChartsTheme() {
  echarts.registerTheme("techbazaar", {
    color: ECHART_PALETTE,
    backgroundColor: "transparent",
    textStyle: ECHART_TEXT_STYLE,
    title: {
      textStyle: { color: "#1E293B", fontWeight: 600, fontSize: 14 },
      subtextStyle: { color: "#64748B", fontSize: 12 },
    },
    legend: {
      textStyle: { color: "#64748B", fontSize: 11 },
      itemWidth: 10,
      itemHeight: 10,
    },
    tooltip: ECHART_TOOLTIP,
    categoryAxis: {
      axisLine: ECHART_AXIS_LINE,
      axisTick: { show: false },
      axisLabel: ECHART_AXIS_LABEL,
      splitLine: { show: false },
    },
    valueAxis: {
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: ECHART_AXIS_LABEL,
      splitLine: ECHART_SPLIT_LINE,
    },
  });
}
